import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/header',
    name: 'Header',
    component: () => import('../views/Header.vue')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Home.vue'),
    meta:{
      isBanner:true,
    }
  },
  {
    path: '/list/:menuId',
    name: 'List',
    component: () => import('../views/List.vue'),
  },
  {
    path: '/listCenter/:menuId',
    name: 'ListCenter',
    component: () => import('../views/ListCenter.vue'),
  },
  {
    path: '/listTeach/:menuId',
    name: 'ListTeach',
    component: () => import('../views/ListTeach.vue'),
  },
  {
    path: '/list/:menuId',
    name: 'List',
    component: () => import('../views/List.vue'),
  },
  {
    path: '/detail/:contentId',
    name: 'Detail',
    component: () => import('../views/Detail.vue'),
  },
  // 手持端登录
  {
    path:'/mobileLogin',
    name: 'mobileLogin',
    component: () => import('../views/Mobile/components/login.vue')
  },
  {
    path:'/touGe',
    name:'touGe',
    component:()=>import('../views/TouGe.vue'),
    meta: {
      isBanner: true
    }
  },
  // 选择预约
  {
    path:'/applySelect',
    name:'applySelect',
    component:()=>import('../views/Mobile/SearchApplyList.vue'),
    meta: {
      isBanner: true
    }
  },
  // 实验教室列表
  { 
    path:'/labList',
    name:'labList',
    component:()=>import('../views/Mobile/labList.vue'),
    meta: {
      isBanner: true
    }
  },
  { // 学院列表，注意下边还有个title要加上
    path:'/collegeList',
    name:'collegeList',
    component:()=>import('../views/Mobile/collegeList.vue'),
    meta: {
      isBanner: true
    }
  },
  // 预约界面
  {
    path:'/reservation',
    name:'reservation',
    component:()=>import('../views/Mobile/reservation.vue'),
    meta: {
      isBanner: true
    }
  },
//   我的预约
  {
    path:'/myApply',
    name:'myApply',
    component:()=>import('../views/Mobile/SearchApplyList.vue'),
  //  component:()=>import('../views/Mobile/myApply.vue'),
    meta: {
      isBanner: true
    }
  },
]
//阻止冲突点击报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if(to.name!='Detail') document.title='计算机国家级实验教学示范中心'
  let funTitleList = ['applySelect','myApply','reservation','collegeList']
  if(funTitleList.includes(to.name)) document.title = '教学实验室预约'
  //这里获取路由传值
  if('labList' == to.name) document.title = to.query.name
  document.getElementById('app').scrollTop=0
  next()
})
export default router
